module.exports = __webpack_public_path__ + "img/lianti.103af848.png";